import React, { useState, useRef, useEffect } from "react";
import { Empty, Button, Checkbox, Select, Input } from "antd";
import { useNavigate } from "react-router-dom";

import "./TableSelectable.scss";
import useSubUserStore from "../../store/subUserModal.store";
import useMembersStore from "../../store/members.store";

export default function NewRTableSelectable({
  isClickable = false,
  titleList,
  data,
  isEditField = true,
  groupnamelist,
  projectData
}){ 
  const { removeMember } = useSubUserStore();
  const { updateUserDetails } = useMembersStore();

  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const ResetCheckBox = () => {
    var checkBoxResetArray = data?.map((item) => {
      return {
        Name: item.username,
        MobileNo: item.contact,
        EmailID: item.email,
        EmpID: item.empid,
        Role: item.designation,
        Permission: item.permission,
        LeaveGroup:item.leavegroup,
        LPermission:item.leavepermission,
        TSPermission:item.tspermission,
        MemberID: item.memberID,
        Project: item.project,
        isSelected: false,
      };
    });
    setCheckBoxData(() => [...checkBoxResetArray]);
  };


  const selectGroupList = Object.keys(groupnamelist || {}).map(key => ({
      value: groupnamelist[key],
      label: key,
      })); 
      
  useEffect(() => {
    const checkBoxArray = data?.map((item) => {
      return {
        Name: item.username,
        MobileNo: item.contact,
        EmailID: item.email,
        EmpID: item.empid,
        Role: item.designation,
        Permission: item.permission,
        LeaveGroup:item.leavegroup,
        LPermission:item.leavepermission,
        TSPermission:item.tspermission,        
        MemberID: item.memberID,
        Project: item.project,
        isSelected: false,
      };
    });
    setCheckBoxData(checkBoxArray);
  }, [data]);

  if (!data) {
    return <Empty style={{ margin: "60px" }} />;
  }

  function enableDbUpdate() {
    for (let idx = 0; idx < checkBoxData.length; idx++) {
      console.log(
        "enableDbUpdate checkBoxArray",
        idx,
        checkBoxData[idx].selected
      );
      if (checkBoxData[idx].isSelected) {
        return true;
      }
    }
    return false;
  }
  const onCheckBoxChange = (e) => {
    if (e.target.checked) {
      checkBoxData[e.target.value].isSelected = true;
    } else {
      checkBoxData[e.target.value].isSelected = false;
    }
    if (enableDbUpdate() == true) {
      setUpdateAvailable(true);
    } else {
      setUpdateAvailable(false);
    }
    setCheckBoxData(() => [...checkBoxData]);
  };

  const OnSelectChange = (value, field,rowIndex) => {
    setCheckBoxData(() => {
      const newArray = [...checkBoxData];
      if (field === "designation") {
        newArray[rowIndex].Role = value;
      } else if (field === "permission") {
        newArray[rowIndex].Permission = value;
      }else if (field === "leavepermission") {
        newArray[rowIndex].LPermission = value;
      }else if (field === "tspermission") {
        newArray[rowIndex].TSPermission = value;
      }else if (field === "leavegroup") {
        newArray[rowIndex].LeaveGroup = value;
      }else if (field === "project") {
        newArray[rowIndex].Project = value;
      }
      return newArray;
    });
  };

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const getUpdated = (rowIndex) => {
    return checkBoxData[rowIndex]?.isSelected;
  };

  const handleRemove = () => {
    const removedUsers = checkBoxData.filter((item) => item.isSelected);
    removedUsers.forEach((element) => {
      removeMember(element.MemberID);
    });
    setUpdateAvailable(false);
    ResetCheckBox();
  };

  const handleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedValues = [...checkBoxData];
    updatedValues[index] = { ...updatedValues[index], [name]: value };
    setCheckBoxData(updatedValues);
  };

  const encodeJson = (updateType) =>{

    let encodedJsonValues ={};
    
    //get company details
    encodedJsonValues._id="Not used"
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    encodedJsonValues.qhoid= userData.qhoid;
    encodedJsonValues.accounttype= userData.account_type ;

    //now fill the parameters
    encodedJsonValues.userlist =[];
    
    var num=0
    for(let idx = 0; idx < checkBoxData.length; idx++){
        //console.log("checkBoxData", idx,checkBoxData[idx])
        if (checkBoxData[idx].isSelected && updateType =="USER_STATUS" ) {
            encodedJsonValues.userlist[num]={};
            encodedJsonValues.userlist[num].name =checkBoxData[idx].Name;
            encodedJsonValues.userlist[num].qhuid =data[idx].memberID; 
            encodedJsonValues.userlist[num].role =checkBoxData[idx].Role; 
            encodedJsonValues.userlist[num].mobile =checkBoxData[idx].MobileNo; 
        encodedJsonValues.userlist[num].emp_id = checkBoxData[idx].EmpID;
        encodedJsonValues.userlist[num].permission =
          checkBoxData[idx].Permission;
            encodedJsonValues.userlist[num].tspermission =checkBoxData[idx].TSPermission; 
            encodedJsonValues.userlist[num].leavepermission =checkBoxData[idx].LPermission; 
            encodedJsonValues.userlist[num].leavegroup =checkBoxData[idx].LeaveGroup; 
            encodedJsonValues.userlist[num].project =checkBoxData[idx].Project; 
            num++;
        }         
    }        
    //get the current date
    let newDate = getTimeNow()
    encodedJsonValues.updatetype = updateType
    encodedJsonValues.updatedby= userData.qhuid;
    encodedJsonValues.updatedbyname= userData.username;
    encodedJsonValues.updatedon    = newDate;
         
    return encodedJsonValues
}

const handleUpdateStatus = (value) => {
    var jasonValues= encodeJson("USER_STATUS")
    console.log("Users Details Updating", jasonValues)
    updateUserDetails({
        jasonValues
    });
    ResetCheckBox();
    setUpdateAvailable(false);
}

const displayPermission = (permission) => {
   if(permission == "superadmin") return "Super Admin"
   if(permission == "admin") return "Admin"
   if(permission == "user") return "User"
}
  const handleSelectAll = () => {
    const tempCheckBoxData = [...checkBoxData];
    if (selectAll) {
      tempCheckBoxData.forEach((item) => {
        item.isSelected = false;
      });
      setCheckBoxData(tempCheckBoxData);
      setUpdateAvailable(false);
    } else {
      tempCheckBoxData.forEach((item) => {
        item.isSelected = true;
      });
      setCheckBoxData(tempCheckBoxData);
      setUpdateAvailable(true);
    }
    setSelectAll(!selectAll);
  };
  
  return (
    <div className="rtable-selectable-wrapper">
      <div className="rtable-selectable-btn-wrapper">
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleUpdateStatus}
        >
          Update
        </Button>
        <Button
          className="rtable-selectable-btn"
          disabled={!updateAvailable}
          onClick={handleRemove}
        >
          Remove
        </Button>
      </div>
      <div
        className="rtable-title-wrapper"
        style={{
          gridTemplateColumns: `50px 50px 1fr 1fr repeat(${
            titleList.length - 4
          }, 2fr)`,
        }}
      >
        {titleList.map((title) =>
          title === "Select" ? (
            <div className="rtable-title">
              <Checkbox
                onChange={handleSelectAll}
                checked={selectAll}
              ></Checkbox>
            </div>
          ) : (
            <div className="rtable-title">{title}</div>
          )
        )}
      </div>
      {data?.map((table, rowIndex) => (
        <div
          key={table.id}
          className="rtable-info-wrapper"
          style={{
            gridTemplateColumns: `50px 50px 1fr 1fr repeat(${
              titleList.length - 4
            }, 2fr)`,
            cursor: isClickable && "pointer",
          }}
        >
          {Object.keys(table)?.map((tableInfo, idx) => (
            <div
              className={`rtable-info${
                tableInfo === "email" ? " rtable-info-email" : ""
              }`}
            >
              {isEditField ? (
                <div className="edit-field-wrapper">
                  <>
                    {tableInfo === "id" ? rowIndex + 1 : <></>}
                    {tableInfo === "select" ? (
                      <Checkbox
                        value={rowIndex}
                        onChange={onCheckBoxChange}
                        checked={getUpdated(rowIndex)}
                      ></Checkbox>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "empid" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                              fontSize: 10,
                              padding: 2,
                            }}
                            name="EmpID"
                            value={checkBoxData[rowIndex]?.EmpID}
                            placeholder={checkBoxData[rowIndex]?.EmpID}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}{" "}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "username" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: "auto",
                              height: 24,
                              textAlign: "center",
                            }}
                            name="Name"
                            value={checkBoxData[rowIndex]?.Name}
                            placeholder={checkBoxData[rowIndex]?.Name}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "contact" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Input
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="MobileNo"
                            value={checkBoxData[rowIndex].MobileNo}
                            placeholder={checkBoxData[rowIndex].MobileNo}
                            onChange={(event) => handleChange(event, rowIndex)}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "email" ? (
                      <>
                          {table[tableInfo]}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "designation" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="Role"
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo,rowIndex);
                            }}
                            placeholder={checkBoxData[rowIndex].Role}
                            options={[
                                { value: 'Trainee Recruiter', label: 'Trainee Recruiter' },
                                { value: 'Recruiter', label: 'Recruiter' },
                                { value: 'Lead Recruiter', label: 'Lead Recruiter' },
                                { value: 'HR Manager', label: 'HR Manager'},
                                { value: 'Group Manager', label: 'Group Manager' },
                                { value: 'Procurement', label: 'Procurement'}, 
                                { value: 'Tech Lead', label: 'Tech Lead'}, 
                                { value: 'Manager', label: 'Manager'}, 
                                { value: 'COO', label: 'COO' },
                                { value: 'CHRO', label: 'CHRO' },
                                { value: 'CEO', label: 'CEO'},                                 
                                { value: 'Others', label: 'Others' },                              
                            ]}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    {tableInfo === "project" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="project"
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo,rowIndex);
                            }}
                            placeholder={checkBoxData[rowIndex].Project}
                            options={projectData}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {tableInfo === "tspermission" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="tspermission"
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo,rowIndex);
                            }}
                            placeholder={checkBoxData[rowIndex].TSPermission}
                            options={[
                                { value: 'Approvar', label: 'Approvar' },
                                { value: 'User', label: 'User' },                              
                            ]}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )} 
                    {tableInfo === "leavepermission" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="leavepermission"
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo,rowIndex);
                            }}
                            placeholder={checkBoxData[rowIndex].LPermission}
                            options={[
                                { value: 'Approvar', label: 'Approvar' },
                                { value: 'User', label: 'User' },                              
                            ]}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )} 
                    {tableInfo === "leavegroup" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            name="leavegroup"
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo,rowIndex);
                            }}
                            placeholder={checkBoxData[rowIndex].LeaveGroup}
                            options={selectGroupList}
                          />
                        ) : (
                          table[tableInfo]
                        )}
                      </>
                    ) : (
                      <></>
                    )}                                                                               
                    {tableInfo === "onboardingDate" ? table[tableInfo] : <></>}
                    {tableInfo === "memberID" ? table[tableInfo] : <></>}
                    {tableInfo === "permission" ? (
                      <>
                        {getUpdated(rowIndex) === true ? (
                          <Select
                            style={{
                              width: 200,
                              height: 24,
                              textAlign: "center",
                            }}
                            onChange={(value) => {
                              OnSelectChange(value, tableInfo,rowIndex);
                            }}
                            placeholder={displayPermission(checkBoxData[rowIndex].Permission)}
                            options={rowIndex === 0 ? [                           
                              {
                                value: "superadmin",
                                label: "Super Admin",
                              },
                            ]:[                           
                              {
                                value: "superadmin",
                                label: "Super Admin",
                              },
                              {
                                value: "admin",
                                label: "Admin",
                              },
                              {
                                value: "user",
                                label: "User",
                              },
                            ]}
                          />
                        ) : (
                          displayPermission(table[tableInfo])
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                  </>
                </div>
              ) : (
                table[tableInfo]
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
